"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFilterActions = void 0;
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var doshx_controls_web_1 = require("doshx_controls_web");
var IFilterAction_1 = require("../../../../../../interfaces/IFilterAction");
var useSearchDebounce_1 = require("../../../../../../hooks/useSearchDebounce");
var branch_list_thunk_1 = require("../../../../../../reducers/slices/branch/thunks/get/branch_list_thunk");
var pages_1 = require("../../../../../../constants/pages");
function useFilterActions(_a) {
    var branches = _a.branches;
    var dispatch = (0, react_redux_1.useDispatch)();
    var _b = (0, useSearchDebounce_1.useSearchDebounce)(), search = _b[0], setSearch = _b[1];
    var _c = (0, react_1.useState)("ALL"), selectedBranch = _c[0], setSelectedBranch = _c[1];
    var _d = (0, react_1.useState)(null), isCardLinked = _d[0], setIsCardLinked = _d[1];
    var _e = (0, react_1.useState)(null), selectedFromDate = _e[0], setSelectedFromDate = _e[1];
    var _f = (0, react_1.useState)(null), selectedToDate = _f[0], setSelectedToDate = _f[1];
    var branchFilters = (0, react_1.useMemo)(function () {
        var branchFilters = Array.from(new Set(branches.map(function (branch) { return ({
            label: branch.display_name,
            value: branch._id,
        }); })));
        return __spreadArray([{ label: "ALL", value: "ALL" }], branchFilters, true);
    }, [branches]);
    var onSetSelectedBranch = (0, react_1.useCallback)(function (value) {
        setSelectedBranch(value);
    }, [branchFilters]);
    var cardLinkFilters = [
        { label: "Yes", value: "true" },
        { label: "No", value: "false" },
    ];
    var onIsCardLinkedSelected = (0, react_1.useCallback)(function (value) {
        setIsCardLinked(value);
    }, []);
    var onSetSelectedFromDates = (0, react_1.useCallback)(function (value) {
        setSelectedFromDate(doshx_controls_web_1.Utilities.formatDateTime(value, "YYYY-MM-DD"));
    }, []);
    var onSetSelectedToDates = (0, react_1.useCallback)(function (value) {
        setSelectedToDate(doshx_controls_web_1.Utilities.formatDateTime(value, "YYYY-MM-DD"));
    }, []);
    var handleSearch = (0, react_1.useCallback)(function (searchString) {
        setSearch(searchString);
    }, []);
    (0, react_1.useEffect)(function () {
        dispatch((0, branch_list_thunk_1.branch_list_thunk)(__assign(__assign({}, pages_1.initialPaginationValues), { search_string: search })));
    }, [search]);
    var filterActions = (0, react_1.useMemo)(function () { return [
        {
            type: IFilterAction_1.FilterTypeEnum.Dates,
            key: "from_date",
            label: "From Date",
            value: selectedFromDate,
            onChange: onSetSelectedFromDates,
        },
        {
            type: IFilterAction_1.FilterTypeEnum.Dates,
            key: "to_date",
            label: "To Date",
            value: selectedToDate,
            onChange: onSetSelectedToDates,
        },
        {
            type: IFilterAction_1.FilterTypeEnum.RadioGroup,
            key: "branch_id",
            label: "Branch",
            value: selectedBranch,
            options: branchFilters,
            onChange: onSetSelectedBranch,
            onSearch: handleSearch,
            defaultOpen: true,
        },
        {
            type: IFilterAction_1.FilterTypeEnum.RadioGroup,
            key: "is_card_linked",
            label: "Card Linked",
            value: isCardLinked,
            options: cardLinkFilters,
            onChange: onIsCardLinkedSelected,
            defaultOpen: true,
        },
    ]; }, [
        branchFilters,
        onSetSelectedBranch,
        selectedBranch,
        cardLinkFilters,
        onIsCardLinkedSelected,
        isCardLinked,
        onSetSelectedFromDates,
        selectedFromDate,
        onSetSelectedToDates,
        selectedToDate,
    ]);
    var resetFilters = (0, react_1.useCallback)(function () {
        setSelectedBranch("ALL");
        setIsCardLinked(null);
        setSelectedFromDate(null);
        setSelectedToDate(null);
    }, []);
    (0, react_1.useEffect)(function () {
        resetFilters();
    }, []);
    return (0, react_1.useMemo)(function () { return ({
        filterActions: filterActions,
    }); }, [filterActions]);
}
exports.useFilterActions = useFilterActions;
